export default __webpack_public_path__ + "static/bold-0d0bf56e1e7f61d4cc1029c35a58407c.woff2";